<template>
  <el-dialog
    width="720px"
    :title="`批量编辑“${title}”集`"
    :visible.sync="modelValue"
    custom-class="relic-detail-census-edit relic-dialog"
    :before-close="handleClose"
  >
    <div>
      <!-- 全选 -->
      <el-checkbox
        v-if="localAllEditImgs.length"
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
      >
        全选
      </el-checkbox>
      <!-- 批量删除 -->
      <el-button
        type="text"
        icon="iconfont icon-bianji"
        @click="openConfrimBatchDelete"
        class="batch-delete flex-align"
        v-if="getBatchDeleteList.length > 0"
      >
        批量删除
      </el-button>
      <!-- 图片列表 -->
      <ul class="edit-imgs">
        <li
          v-for="img in localAllEditImgs"
          :key="img.relicPhotoAutoIncrementId"
          class="edit-imgs__item"
        >
          <img :src="img.url" alt="" />
          <!-- modal -->
          <el-checkbox
            v-model="img.checked"
            class="edit-imgs__checkbox"
          ></el-checkbox>
          <div class="edit-imgs__modal flex-align">
            <el-button
              class="edit-imgs__action"
              type="primary"
              :class="{ showMap: img.showInMap }"
              @click="
                handleShowInMap(
                  img.relicPhotoAutoIncrementId,
                  img.relicDrawingAutoIncrementId,
                  img.showInMap
                )
              "
            >
              地图显示
            </el-button>
            <el-button
              class="edit-imgs__action"
              type="primary"
              @click="
                openConfrim(
                  img.relicPhotoAutoIncrementId,
                  img.relicDrawingAutoIncrementId
                )
              "
            >
              删除图片
            </el-button>
          </div>
        </li>
      </ul>
    </div>
    <!-- footer -->
    <!-- <template v-slot:footer class="edit-footer">
      <el-button
        plain
        type="primary"
        class="edit-footer__btn edit-footer__btn--cancel"
      >
        取消
      </el-button>
      <el-button
        type="primary"
        class="edit-footer__btn edit-footer__btn--confirm"
      >
        保存
      </el-button>
    </template> -->
  </el-dialog>
</template>

<script>
import { modelMixin } from '../../assets/js/mixins/model';

export default {
  name: 'RelicDetailCensusEdit',
  mixins: [modelMixin],
  props: {
    title: {
      type: String,
      default: ''
    },
    allEditImgs: {
      type: Array,
      required: true
    },
    imgType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      localAllEditImgs: []
    }
  },
  watch: {
    allEditImgs(newVal){
      this.localAllEditImgs = newVal.map(item => {
        return {
          ...item,
          checked: false
        }
      })
    }
  },
  computed: {
    checkAll: {
      get() {
        return (
          this.localAllEditImgs.length &&
          this.localAllEditImgs.every(item => item.checked)
        );
      },
      set(val) {
        this.localAllEditImgs.forEach(item => (item.checked = val));
      }
    },
    // 半选状态
    isIndeterminate() {
      const checkedCount = this.localAllEditImgs.filter(item => item.checked).length;
      return checkedCount > 0 && checkedCount < this.localAllEditImgs.length;
    },
    // 获取选中的批量删除图片列表
    getBatchDeleteList() {
      return this.localAllEditImgs.filter(item => item.checked);
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('onCloseUpdatePhoto', this.imgType);
      done();
    },
    handleShowInMap(photoId, drawId, showInMap) {
      if (this.imgType == 1) {
        this.$emit('onChangePhotoShowInMap', photoId, showInMap);
      } else if (this.imgType == 2) {
        this.$emit('onChangeDrawShowInMap', drawId, showInMap);
      }
    },
    /**
     * 删除确认弹窗回掉
     */
    openConfrim(photoId, drawId) {
      this.$confirm('确定要删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'attribute-delete-msgbox',
        center: true
      })
        .then(() => {
          if (this.imgType == 1) {
            this.$emit('onConfirmDeletePhoto', photoId);
          } else if (this.imgType == 2) {
            this.$emit('onConfirmDeleteDraw', drawId);
          }
        })
        .catch(() => {
          this.$prompt('已取消删除');
        });
    },
    // 批量删除确认弹窗回调
    openConfrimBatchDelete() {
      this.$confirm('确定要删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'attribute-delete-msgbox',
        center: true
      })
        .then(() => {
          if (this.imgType == 1) {
            let relicPhotoAutoIncrementIds = this.getBatchDeleteList.map(
              item => item.relicPhotoAutoIncrementId
            );
            this.$emit('onConfirmDeletePhoto', relicPhotoAutoIncrementIds);
          } else if (this.imgType == 2) {
            let relicDrawingAutoIncrementIds = this.getBatchDeleteList.map(
              item => item.relicDrawingAutoIncrementId
            );
            this.$emit('onConfirmDeleteDraw', relicDrawingAutoIncrementIds);
          }
        })
        .catch(() => {
          this.$prompt('已取消删除');
        });
    },
    handleCheckAllChange(val) {
      this.localAllEditImgs.forEach(item => (item.checked = val));
    }
  }
};
</script>

<style lang="scss">
.relic-detail-census-edit {
  position: relative;
  .el-dialog {
    &__header {
      padding-top: 24px;
      padding-left: 32px;
    }
    &__body {
      padding: 20px 21px;
      height: 820px;
    }
    &__footer {
      padding: 20px;
      padding-right: 28px;
    }
  }
  .batch-delete {
    position: absolute;
    right: 24px;
    top: 24px;
    font-size: 20px;
    text-decoration: none;
    .iconfont {
      font-size: 26px;
      margin-right: 4px;
    }
  }
  .edit {
    &-footer {
      &__btn {
        margin-left: 40px;
        width: 70px;
        height: 40px;
        border-radius: 5px;
      }
    }
    &-imgs {
      display: flex;
      flex-wrap: wrap;
      max-height: 720px;
      overflow-y: auto;
      &__item {
        img {
          width: 200px;
          height: 143px;
        }
        position: relative;
        margin-right: 30px;
        margin-bottom: 30px;
        width: 200px;
        height: 143px;
        background-color: #f2f2f2;
        border: 1px solid #000;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
      &__modal {
        position: absolute;
        justify-content: space-between;
        width: 100%;
        left: 0;
        bottom: 0;
      }
      &__img {
      }
      &__action {
        flex: 1;
        height: 43px;
        border-radius: 0;
        background-color: rgba(0, 0, 0, 0.3);
        & + .el-button {
          margin-left: 3px;
        }
      }
      &__checkbox {
        position: absolute;
        left: 0;
        top: 0;
      }
      .showMap {
        background-color: $color-primary;
      }
    }
  }
}
.attribute-delete-msgbox {
  width: 300px;
  height: 170px;
  .el-message-box__btns {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-around;
    width: 200px;
    margin: 0 auto;
    margin-top: 20px;
    button:nth-child(2) {
      margin-left: 0;
    }
  }
  .el-button {
    background-color: $color-primary;
    color: #fff;
  }
}
</style>
